import { Link } from 'gatsby'
import { InsuranceCartIcon } from 'src/components/Icons/InsuranceCartIcon'

const CartFeedbackInsuranceCard = ({
  name,
  price,
  onClick,
}: {
  name: string
  price: string
  onClick: () => void
}) => {
  return (
    <div className="flex items-center bg-restructure-background-insurance py-3 pl-3 pr-6">
      <div className="min-w-6 mr-2">
        <InsuranceCartIcon />
      </div>
      <div className="flex flex-col max-w-[150px] gap-2">
        <p className="text-xs font-medium text-restructure-primary">{name}</p>
        <p className="text-xs font-normal text-restructure-primary">
          {price} à vista
        </p>
      </div>
      <Link
        className="underline min-w-fit ml-auto text-xs font-medium text-restructure-primary"
        to="/seguro-bike"
        onClick={onClick}
      >
        Saiba mais
      </Link>
    </div>
  )
}

export default CartFeedbackInsuranceCard
